import { createSelector } from '@reduxjs/toolkit';

export const selectScoreMatrix = state => state.scoreMatrix || {};

export const selectScoreMatrixState: (state) => object = createSelector([selectScoreMatrix], scoreMatrix => {
  return scoreMatrix.data || {};
});
